import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { COLORS } from '~/src/styles/tokens/colors';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { FONTS } from '~/src/styles/style-helpers/font-helper';
import { MAX_567 } from '~/src/styles/tokens/break-points';

export const AttachFileContainer = styled.div`
    width: ${rem(400)};
    min-height: ${rem(52)};
    padding: ${rem(8)} ${rem(18)} ${rem(8)} ${rem(20)};
    background-color: ${COLORS.backgroundLightSecondary};
    border-radius: ${BORDER_RADIUS.normal8};
    justify-content: space-between;
    flex-wrap: nowrap;

    ${mediaQuery(
        { maxWidth: MAX_567 },
        css`
            width: 100%;
        `,
    )};
`;

export const ImageWrapper = styled.div`
    width: fit-content;
    position: relative;
    align-items: center;
    margin-right: ${rem(20)};
    justify-content: flex-start;
`;

export const BodyWrapper = styled.div`
    width: 100%;
    display: grid; // чтобы корректно работал text-overflow: ellipsis для FileName
`;

export const BodyContainer = styled.div`
    width: 100%;
    flex-wrap: nowrap;
`;

export const CrossContainer = styled.div`
    margin-left: ${rem(14)};
    align-items: center;
`;

export const CrossWrapper = styled.div`
    width: fit-content;
    height: fit-content;
`;

export const FileName = styled.div`
    width: 100%;
    display: block;
    max-height: ${rem(20)};
    ${FONTS.compact.regular.size14};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const FileSize = styled.div<{ hasError: boolean }>`
    ${FONTS.compact.regular.size12};
    color: ${(p) => p.hasError ? `${COLORS.textNegative}` : `${COLORS.textSecondary}`};
`;

export const LoadingBar = styled.div<{ progress: number }>`
    position: relative;
    width: 100%;
    height: ${rem(4)};
    background-color: ${COLORS.backgroundStroke};
    border-radius: ${BORDER_RADIUS.onePx};
    margin-bottom: ${rem(6)};

    ::after {
        content: '';
        position: absolute;
        width: ${(p) => p.progress}%;
        height: 4px;
        background-color: ${COLORS.accentPositive};
    }
`;
